import styled from 'styled-components/native';

import { moderateScale } from '../../../../utils/scaleHelpers';
import {
  BorderlessButton,
  LargeProgressButton,
  P2,
} from '../../../base_ui';

export const AddAccountContainer = styled.View`
  margin: ${moderateScale(30)}px 0 ${moderateScale(16)}px;
  text-align: center;
`;

export const BoldText = styled.Text`
  font-family: ${({ theme: { fontFamilies: { secondaryFontBold } } }) => secondaryFontBold};
`;

export const ClearButton = styled(BorderlessButton).attrs(({
  theme: { colors: { linkText }, fontFamilies: { secondaryFont } },
  titleStyle,
}) => ({ titleStyle: [titleStyle, { color: linkText, fontFamily: secondaryFont }] }))`
  margin-top: ${moderateScale(10)}px;
  padding: 0 ${moderateScale(14)}px;
`;

export const FormContainer = styled.View`
  align-items: center;
  flex: auto;
  margin: 0 auto;
  max-width: ${moderateScale(327)}px;
`;

export const ImageContainer = styled.View`
  align-items: center;
  padding: ${moderateScale(18)}px 0 0;
`;

export const InfoSectionContainer = styled.View`
  margin: ${moderateScale(8)}px auto ${moderateScale(8)}px;
  width: ${moderateScale(327)}px;;
`;

export const RemoveAccountContainer = styled.View`
  align-items: center;
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  margin: ${moderateScale(20)}px 0 ${moderateScale(32)}px;
  width: ${moderateScale(327)}px;;
`;

export const SecondAccountButton = styled(BorderlessButton).attrs(({ titleStyle }) => ({
  titleStyle: [
    titleStyle,
    {
      paddingLeft: moderateScale(4),
      paddingVertical: 0,
    },
  ],
}))``;

export const StyledImage = styled.Image`
  height: ${moderateScale(84)}px;
  width: ${moderateScale(327)}px;
`;

export const StyledLargeProgressButton = styled(LargeProgressButton)`
  align-self: center;
  margin-bottom: ${moderateScale(35)}px;
  margin-top: ${({ $hasMarginTop }) => $hasMarginTop ? moderateScale(24) : 0}px;
`;

export const StyledPhoneLinkText = styled.Text`
  color: ${({ theme: { colors: { linkText } } }) => linkText};
`;

export const StyledText = styled(P2)`
  margin-bottom: ${moderateScale(8)}px;
`;

export const TextWrapper = styled.View`
  margin: ${moderateScale(16)}px 0 ${moderateScale(8)}px;
`;

export const UseExistingContainer = styled.View`
  align-items: center;
  padding-bottom: ${moderateScale(26)}px;
`;
